import { fetchWithTimeout } from 'global-utils/api';
import { GEO_API_URL } from 'config/api';
import { sendErrorLog } from 'global-utils/audit';

async function fetchGeoLocation() {
  let result;
  try {
    result = await fetchWithTimeout(GEO_API_URL);

    if (result.status === 404) {
      sendErrorLog({
        errorCode: '404',
        origin: 'whereami'
      });
    }
  } catch (err) {
    console.error(err);
  }
  return result;
}

export default fetchGeoLocation;
